import { createListLoadingReducer } from './utils';

export default createListLoadingReducer('AVAILABLE_RESOURCES');
